module.exports = __webpack_public_path__ + "img/Hans Bättigsm.234badd8.jpg";